

<script>
import {Select} from 'element-ui';
export default {
  name: 'ESelect',
  extends: Select,
  methods: {
    toggleMenu(e) {
      // 当开启filterable时，判断是否input输入框，如果input框有值，则不触发toggle
      let $target = e.target;
      let isInput = $target.tagName.toLowerCase() === 'input';
      if(isInput&&this.filterable&&$target.value) {
        // 如果是多选，直接返回，不执行toggle
        if(this.multiple) return;
        let selectedText = this.selected?.$el?.innerText||'';
        // 如果是单选，判断当前input框的值是否是当前选中项，如果不是，则不执行toggle
        if($target.value!=selectedText) return;
      }

      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }
        if (this.visible) {
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },
  },

}
</script>